<template>
  <div>
    <div class="init-load" v-if="load">
      <loading :fullscrean="true" init="true"/>
    </div>
    <div id="app" v-else-if="empresa.status === '2'" class="android_platform lecard-go" :class="theme">
      <router-view/>
    </div>
    <status-empresa v-else :status="empresa.status"/>

    <div class="modal modal-loading d-block" v-if="loadingGeral" style="z-index: 2090">
      <div class="modal-content border-0">
        <div style="padding: 24px 0 32px">
          <loading :text="loadingGeral"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Loading from "../../components/Loading";
  import StatusEmpresa from "../../components/StatusEmpresa";

  export default {
    name: 'App',
    components: {Loading, StatusEmpresa},
    data() {
      return {
        load: true,
        user: {},
        empresa: { status: '2' },
        tipo_pedido: null,
        theme: 'theme-1'
      }
    },

    methods: {
      getEmpresa(dominio, tipo_pedido, callback) {
        this.load = true;
        this.$http.get('v2/empresa', { params: { dominio, tipo_pedido } }).then(response => {
          if (response.data && response.data.empresa) {
            this.empresa = response.data.empresa;
            this.$store.state.cardapio = response.data.cardapio;
            this.$store.state.url = '/' + this.empresa.dominio_delivery;
            this.theme = `theme-${this.empresa.id_theme}`;

            if (this.modo_catalogo) {
              this.theme = `theme-2`;
              this.empresa.id_theme = '3';
            }

            const fidelidade = this.empresa.fidelidade;

            if (fidelidade && fidelidade.lecard_go !== '1') {
              this.empresa.fidelidade = null;
            }

            if (this.empresa.status === '2') {
              this.$helpers.setEmpresaStatus(this, this.empresa, () => {
                callback();
              });

            } else {
              callback();
            }

          } else {
            this.load = false;
            this.$router.push('/404');
          }

        }, res => {
          this.empresa.status = '1';
          this.load = false;
        });
      },

      autenticar(token) {
        this.$http.post(this.empresa.token + '/login', {token})
          .then(res => {
            if (res && res.data.success) {
              this.$store.commit('setDataUser', res.data);
              this.user = res.data.dados;

              if (this.$route.name === 'Zap' && localStorage.getItem('pedidos') && localStorage.getItem('pedidos') > 0) {
                this.$router.push('/' + this.empresa.dominio_delivery);
              }
            }

            this.load = false;
            this.setColor(this.empresa.theme_color);

          }, res => {
            this.load = false;
            let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
            this.$swal(msg).then(() => {
              if (res.status === 401) {
                this.$store.commit('logout');
                if (this.$route.name !== 'Restaurante') {
                  this.$router.push('/' + this.empresa.dominio_delivery);
                }
              }
            });
          });
      },

      getSacola() {
        const sacolaTemp = this.$helpers.parseJSONObject(localStorage.getItem('sacola'));
        const nolocal = this.$helpers.parseJSONObject(localStorage.getItem('nolocal'));

        if (nolocal && (nolocal.expiracao > new Date().getTime())) {
          let sacola = sacolaTemp || { produtos: [], expiracao: nolocal.expiracao };
          sacola.origin = '4';
          sacola.tipo_pedido = nolocal.tipo_pedido || '2';
          this.$store.state.nolocal = nolocal;
          return sacola;

        } else if (sacolaTemp && sacolaTemp.origin !== '4') {
          sacolaTemp.expiracao = sacolaTemp.expiracao || new Date().getTime() + ((1000 * 60 * 60) * 24);
          return sacolaTemp;
        }

        localStorage.removeItem('sacola');
        localStorage.removeItem('nolocal');
        return null;
      },

      hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? (parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16) + ',0.6') : null;
      },

      setColor(color) {
        if (color) {
          document.documentElement.style.setProperty('--lecard-primary', color);
          document.documentElement.style.setProperty('--lecard-secondary', color);
        }

        document.title = `${this.empresa.nome_fantasia} - LeCard`;
      },

      getUserZap(callback) {
        this.$http.get('zap/' + this.$route.params.hash)
          .then(response => {
            if (response.data && response.data.success) {
              const dados = response.data.dados;
              sessionStorage.setItem('session-zap', JSON.stringify(dados));
              this.$store.state.zap = dados;

              if (dados.token) {
                localStorage.setItem(dados.dominio_delivery, dados.token);

              } else {
                localStorage.removeItem('token');
                localStorage.removeItem(dados.dominio_delivery);
              }

              callback(dados.dominio_delivery)

            } else {
              this.$router.push('/404');
              this.load = false;
            }

          }, res => {
            this.load = false;
            this.$router.push('/404');
            // this.$swal(res.data.msg);
          });
      },

      getDadosApp(dominio) {
        const sacola = this.getSacola();
        const tipo_pedido = sacola ? sacola.tipo_pedido : null;
        this.getEmpresa(dominio, tipo_pedido, () => {
          if (sacola && (!sacola.token || sacola.token === this.empresa.token) && sacola.expiracao > (new Date().getTime())) {
            if (!this.empresa.json_config.nolocal) {
              localStorage.removeItem('nolocal');
              sacola.nolocal = '';
              sacola.tipo_pedido = '1';
              sacola.origin = this.origin;
            }

            this.$store.state.sacola = sacola;
            this.$store.commit('setProdutosSacola', sacola);

          } else {
            localStorage.removeItem('sacola');
            localStorage.removeItem('nolocal');
          }

          if (localStorage.getItem(dominio)) {
            this.autenticar(localStorage.getItem(this.empresa.dominio_delivery));

          } else {
            this.load = false;
            localStorage.removeItem('token');
            this.setColor(this.empresa.theme_color);
          }
        });
      },

      initApp() {
        const routes = ["HomeGo", "LeCardGo", "TermosUso", "PoliticaPrivacidade", "NotFound"];

        if (this.$route.query.cupom) {
          localStorage.setItem('ref_cupom', this.$route.query.cupom || '');
        }

        if (this.$route.query.utm_source) {
          sessionStorage.setItem('utm_source', this.$route.query.utm_source || '')
        }

        if (!routes.includes(this.$route.name)) {
          if (["Zap", "ZapMenu"].includes(this.$route.name)) {
            this.getUserZap((dominio) => {
              this.getDadosApp(dominio);
            });

          } else {
            if (sessionStorage.getItem('session-zap')) {
              this.$store.state.zap = JSON.parse(sessionStorage.getItem('session-zap'));
            }

            this.getDadosApp(this.$route.params.id);
          }

        } else {
          this.load = false;
        }
      }
    },

    mounted() {
      console.log('Current version: ' + this.app_version);
      sessionStorage.removeItem('cuponsReadonly');

      setTimeout(() => {
        this.initApp();
      }, 1500);
    },

    computed: {
      loadingGeral() {
        return this.$store.state.load;
      }
    }
  }
</script>

<style>
  .init-load {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    background-color: #F6F7F8;
  }
</style>
